// extracted by mini-css-extract-plugin
export default {"pageWrapper":"Dashboard_pageWrapper__F+-9t","wrapper":"Dashboard_wrapper__kS4Y5","item":"Dashboard_item__jEvaR","link":"Dashboard_link__ajOzb","disabled":"Dashboard_disabled__hahIU"};